export default __webpack_public_path__ + "static/media/Penny Bun4.3d06786b.jpg";